import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as i } from "react";
const c = ({
  title: l,
  titleId: o,
  ...s
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...s,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M497.954 642.031c23.277 0 39.469-17.21 43.518-38.244l4.047-43.981c112.335-18.165 204.429-72.666 204.429-193.135v-1.914c0-119.514-96.141-194.091-237.824-194.091-93.107 0-160.913 31.552-214.549 79.358-14.17 11.473-20.241 26.771-20.241 41.114 0 28.683 25.301 52.585 56.674 52.585 14.167 0 27.324-5.737 37.444-13.385 40.48-34.421 83.998-52.587 137.636-52.587 72.864 0 116.382 37.289 116.382 90.831v1.911c0 60.237-52.625 94.656-147.755 103.262-27.326 2.867-43.518 21.99-39.471 47.806l10.121 82.225c3.036 21.99 20.241 38.244 43.518 38.244zm-77.926 135.77v9.562c0 37.289 30.362 65.971 71.855 65.971s71.853-28.683 71.853-65.971v-9.562c0-37.289-30.359-65.973-71.853-65.973s-71.855 28.685-71.855 65.973",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = i(c);
export {
  m as default
};
